/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateSalesOrderInstallmentDto = {
  /**
   * ID of the sales order
   */
  salesOrderId?: number;
  /**
   * Installment number (1, 2, 3...)
   */
  installmentNumber?: number;
  /**
   * Total number of installments
   */
  installmentTotal?: number;
  /**
   * Due date for this installment
   */
  dueDate?: string;
  /**
   * Installment amount
   */
  amount?: number;
  /**
   * Late fee amount (if applicable)
   */
  lateFee?: number;
  /**
   * Notes for this installment
   */
  notes?: string;
  /**
   * Installment status
   */
  status?: UpdateSalesOrderInstallmentDto.status;
  /**
   * Date when installment was paid
   */
  paidDate?: string;
};
export namespace UpdateSalesOrderInstallmentDto {
  /**
   * Installment status
   */
  export enum status {
    PENDING = 'PENDING',
    PAID = 'PAID',
    OVERDUE = 'OVERDUE',
    CANCELLED = 'CANCELLED',
  }
}
